'use strict';

var React = require('react');
var dom = require('../utils/dom.js');

/**
 * useSafeLayoutEffect enables us to safely call `useLayoutEffect` on the browser
 * (for SSR reasons)
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser.
 *
 * @example
 * ```javascript
 * useSafeLayoutEffect(() => {
 *    window.addEventListener("resize", measure)
 *
 *    return () => {
 *      window.removeEventListener("resize", measure)
 *    }
 * }, [observe])
 * ```
 */
const useSafeLayoutEffect = dom.isBrowser ? React.useLayoutEffect : React.useEffect;

exports.useSafeLayoutEffect = useSafeLayoutEffect;
//# sourceMappingURL=useSafeLayoutEffect.js.map
